module.exports = __webpack_public_path__ + "img/schedules.4fbb9c8e.svg";